<template>
  <div class="home" :class="flag.pay ? 'pop' : ''">
    <div class="head">
      习讯云·双选会
      <div class="wx">
        <div>客服微信</div>
        <img src="../../assets/img/qrcode/enterpeise-service.jpg" alt />
      </div>
      <div class="xcx">
        <div>小程序</div>
        <img src="../../assets/img/qxiaoyunxcx.jpg" alt />
      </div>
      <div class="search">
        <div class="input">
          <i class="el-icon-search"></i>
          <input type="text" placeholder="请输入学校名称" v-model="schName" />
        </div>
        <div class="submit" @click="search">搜索</div>
      </div>
    </div>
    <div class="content">
      <div class="stat">
        <div class="sch-num">
          <div class="label">学校数量</div>
          <div class="value">
            <span>{{school}}</span>所
          </div>
        </div>
        <div class="stu-num">
          <div class="label">学生数量</div>
          <div class="value">
            <span>{{student}}</span>人
          </div>
        </div>
        <div class="com-num">
          <div class="label">企业数量</div>
          <div class="value">
            <span>{{company}}</span>个
          </div>
        </div>
        <div class="job-num">
          <div class="label">专业数量</div>
          <div class="value">
            <span>{{major}}</span>个
          </div>
        </div>
      </div>
      <div class="hot">热门场次</div>
      <div class="schools">
        <div class="school" v-for="item in schoolList" :key="item.id">
          <div class="logo">{{item.fdName}}</div>
          <div class="name">{{item.fdName}}</div>
          <div class="num">
            <div>
              平台学生人数
              <span>{{item.studentNum}}</span>人
            </div>
            <div>
              专业
              <span>{{item.majorNum}}</span>个
            </div>
          </div>
          <div class="join" @click="readSchoolDetail(item.id)">查看详情</div>
        </div>
      </div>
      <!-- <el-pagination
        :total="total"
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :current-page="page"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>-->
      <Pagination ref="pagination" :total="total" @size-change="getList" @current-change="getList" />
    </div>

    <el-dialog :title="title" :visible.sync="flag.addEnterprise" width="900px" :show-close="false" :close-on-click-modal="false">
      <el-steps :active="flag.stepsActive" finish-status="success" align-center style="margin-bottom: 20px;">
        <el-step title="企业信息"></el-step>
        <el-step title="营业执照"></el-step>
      </el-steps>
      <el-form v-if="flag.stepsActive === 0" :model="enterpriseInfo" :rules="rule1" ref="ref1" label-width="150px" :inline="true">
        <el-form-item label="公司名称" prop="e_name">
          <el-input v-model="enterpriseInfo.e_name" placeholder="请填写公司名称"></el-input>
        </el-form-item>
        <el-form-item label="行业类型" prop="trade">
          <el-select v-model="enterpriseInfo.trade" placeholder="请选择行业类型" clearable>
            <el-option v-for="item in arr.trades" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在区域" class="area" required>
          <el-row :gutter="20" style="margin-bottom:0">
            <el-col :span="7">
              <!-- enterpriseInfo.xixun_province_id -->
              <el-form-item prop="xixun_province_id">
                <el-select v-model="enterpriseInfo.xixun_province_id" placeholder="请选择省份" @change="changeProvince">
                  <el-option v-for="item in this.$store.state.provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="xixun_city_id">
                <el-select v-model="enterpriseInfo.xixun_city_id" placeholder="请选择市" @change="changeCity">
                  <el-option v-for="item in arr.cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="xixun_county_id">
                <el-select v-model="enterpriseInfo.xixun_county_id" placeholder="请选择区县">
                  <el-option v-for="item in arr.countyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="enterpriseInfo.address" placeholder="请填写详细地址" style="width: 560px;"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="uscc">
          <el-input v-model="enterpriseInfo.uscc" placeholder="请填写统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact_name">
          <el-input v-model="enterpriseInfo.contact_name" placeholder="请填写联系人"></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="enterpriseInfo.contact_job" placeholder="请填写职位"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="contact_mob">
          <el-input v-model="enterpriseInfo.contact_mob" placeholder="请填写手机号码"></el-input>
        </el-form-item>
        <!-- <el-form-item label="QQ">
          <el-input v-model="enterpriseInfo.contact_qq" placeholder="请填写QQ"></el-input>
        </el-form-item> -->
        <el-form-item label="邮箱">
          <el-input type="email" v-model="enterpriseInfo.contact_email" placeholder="请填写邮箱"></el-input>
        </el-form-item>
        <!-- <el-form-item label="电话" prop="tel">
          <el-input v-model="enterpriseInfo.tel" placeholder="请填写电话"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="传真">
          <el-input v-model="enterpriseInfo.fax" placeholder="请填写传真"></el-input>
        </el-form-item> -->
        <el-form-item label="网址">
          <el-input v-model="enterpriseInfo.site" placeholder="请填写网址"></el-input>
        </el-form-item>
        <el-form-item label="公司介绍">
          <el-input :autosize="{ minRows: 5, maxRows: 8 }" type="textarea" v-model="enterpriseInfo.brief" placeholder="请输入介绍信息" style="width: 560px;"></el-input>
        </el-form-item>
        <el-form-item style="width: 90%; text-align: right;">
          <el-button @click="logout">退 出</el-button>
          <el-button type="primary" @click="addEnterpriseSubmit">下一步</el-button>
        </el-form-item>
      </el-form>
      <div v-if="flag.stepsActive === 1" style="text-align: center;">
        <div class="license">
          <span style="margin-right: 20px;">上传营业执照：</span>
          <license-upload :enterprise_id="enterpriseInfo.id" :operationType="operationType" style="margin:20px" />
        </div>
        <div style="width: 80%; text-align: right; margin-top: 50px;">
          <el-button type="primary" @click="closeEnterprise">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 去认证弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogPayVisible" :show-close="false" :close-on-click-modal="false" width="30%">
      <span>您当前合作的学校需要开通企业会员账号，才可上线发布岗位！</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="logout">退 出</el-button> -->
        <el-button type="primary" @click="toPayPage">立即开通</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination"; // 分页组件
import { validUscc } from "@/assets/js/validate";
import formatter from "@/assets/js/mixins/formatter"; // 公用函数
import defalutLogo from "../../assets/img/default-logo.png";
import baseUrl from "@/api/baseUrl";
import axios from "axios";
import LicenseUpload from "@/components/LicenseUpload";

export default {
  components: {
    Pagination,
    "license-upload": LicenseUpload
  },
  mixins: [formatter],
  data() {
    return {
      total: 0,
      flag: {
        pay: false
      },
      title:'',
      schoolList: [],
      page: 1,
      pageSize: 10,
      schName: "",
      defalutLogo: defalutLogo,
      company: "--",
      major: "--",
      school: "--",
      student: "--",
      flag: {
        addEnterprise: false,
        postJob: false,
        stepsActive: 0
      },
      enterpriseInfo: {
        id: "",
        e_name: "",
        trade: "",
        // province_id: "",
        // city_id: "",
        // county_id: "",
        xixun_city_id: "",
        xixun_county_id: "",
        xixun_province_id: "",
        uscc: "",
        contact_name: "",
        contact_job: "",
        contact_mob: "",
        contact_qq: "",
        contact_email: "",
        address: "",
        tel: "",
        fax: "",
        site: "",
        brief: ""
      },
      arr: {
        trades: [],
        audit_status: [
          { label: "全部", value: "" },
          { label: "待审核", value: "no_pass" },
          { label: "已通过", value: "vanber_pass" },
          { label: "不通过", value: "vanber_refuse" }
        ],
        apply_time: [],
        register_sources: [
          { label: "全部", value: "" },
          { label: "企业注册", value: "self" },
          { label: "万博", value: "vanber" }
        ],
        provinceList: [],
        cityList: [],
        countyList: []
      },
      operationType: "add",
      rule1: {
        e_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        trade: [
          { required: true, message: "请选择行业类型", trigger: "change" }
        ],
        xixun_province_id: [
          { required: true, message: "请选择所在省份", trigger: "change" }
        ],
        xixun_city_id: [
          { required: true, message: "请选择所在城市", trigger: "change" }
        ],
        xixun_county_id: [
          { required: true, message: "请选择所在区县", trigger: "change" }
        ],
        uscc: [{ required: true, trigger: "blur", validator: validUscc }],
        contact_name: [
          { required: true, message: "请填写联系人", trigger: "blur" }
        ],
        contact_mob: [
          { required: true, message: "请填写手机号码", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请填写详细地址", trigger: "blur" }
        ]
      },
      // schoolIds: [],
      dialogPayVisible: false,
      contactSchool: 0
    };
  },
  mounted() {
    // this.getNeedPaySchoolds();
    this.getCompanyInfo();
    this.arr.trades = this.$store.state.trades;
    this.arr.provinceList = this.$store.state.provinces;
    this.getNum();
    this.getList();
  },
  methods: {
    async logout() {
      try {
        let res = await this.$api.account.logout();
        if (res.code === 0) {
          this.$message({
            message: "退出登录!",
            type: "warning"
          });
        } else {
          this.$message({
            message: res.data,
            center: true
          });
        }
      } catch (e) {
        console.log("​catch -> e", e);
      }
      this.$router.push("/login");
    },
    // 获取需要付费的学校id
    async getNeedPaySchoolds() {
      let res = await this.$api.school.getPaySchoolIds();
      let ids = [];
      res.data.forEach(item => {
        ids.push(item.school_id);
      });
      this.schoolIds = ids;
    },
    async getCompanyInfo() {
      let res = await this.$api.info.get();
      if (res.code == 0) {
        if (res.data.length == 0) {
          this.flag.addEnterprise = true;
        } else {
          localStorage.setItem('contact_school',res.data[0].contact_school)
          let res2 = await this.$api.school.getPaySchoolIds();
          let schoolIds = [];
          res2.data.forEach(item => {
            schoolIds.push(item.school_id);
          });
          // this.schoolIds = ids;
          // this.getNeedPaySchoolds();
          // 判断企业是不是需要付费的学校邀请的，和企业是否已经付过费
          let contactSchool = res.data[0].contact_school;
          let payStatus = res.data[0].pay_status;
          if (schoolIds.indexOf(contactSchool) != -1 && payStatus == "no_paid") {
            this.contactSchool = contactSchool;
            this.dialogPayVisible = true;
          }
        }
      }
    },
    async getCities(provinceId) {
      let res = await this.$api.common.getXixunCity(provinceId);
      if (res.code === 0) {
        this.arr.cityList = res.data;
      }
    },
    async getCounties(cityId) {
      let res = await this.$api.common.getXixunCounty(cityId);
      if (res.code === 0) {
        this.arr.countyList = res.data;
      }
    },
    changeProvince(provinceId) {
      this.enterpriseInfo.city_id = null;
      this.enterpriseInfo.county_id = null;
      this.getCities(provinceId);
    },
    changeCity(cityId) {
      this.enterpriseInfo.county_id = null;
      this.getCounties(cityId);
    },
    async getNum() {
      let res = await axios.get(baseUrl + `api/enterpise/website/profile`, {
        withCredentials: true
      });
      if (res.data.code === 0) {
        this.company = res.data.data.company;
        this.major = res.data.data.major;
        this.school = res.data.data.school;
        this.student = res.data.data.student;
      }
    },
    search() {
      this.$refs.pagination.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        name: this.schName
      };
      params = this.delNullVal(params);
      let page = this.$refs.pagination.page;
      let page_size = this.$refs.pagination.page_size;
      let school = await this.$api.school.getSchool(page, page_size, params);
      if (school.code === 0) {
        this.schoolList = school.data.items;
        this.total = school.data.count;
      }
    },
    readSchoolDetail(id) {
      this.$router.push({
        path: "/schoolDetail",
        query: {
          schoolId: id
        }
      });
    },
    // 下一步
    addEnterpriseSubmit() {
      this.$refs["ref1"].validate(valid => {
        if (valid && this.operationType === "add") {
          this.addEnterpriseInfo();
        }
        // if (valid && this.operationType === "update") {
        //   this.updateEnterpriseInfo();
        // }
      });
    },
    closeEnterprise() {
      this.flag.addEnterprise = false;
      this.flag.stepsActive = 0;
      location.reload();
    },
    async addEnterpriseInfo() {
      let params = this.delNullVal(this.enterpriseInfo);
      let res = await this.$api.info.add(params);
      if (res.code === 0) {
        // localStorage.setItem("id", res.data.id);
        // let school_id = this.$route.params.school_id;
        // let id = this.$route.params.id;
        this.flag.stepsActive = 1;
        this.enterpriseInfo.id = res.data.id;
      } else {
        this.$message({
          message: res.msg,
          center: true
        });
      }
    },
    toPayPage() {
      this.dialogPayVisible = false;
      this.$router.push({
        path: "/pay-pc",
        query: {
          school_id: this.contactSchool
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/base.scss";

.home {
  padding: 0 0 100px;
  position: relative;
  .head {
    position: relative;
    width: 100%;
    height: 200px;
    text-align: center;
    background: url("../../assets/img/bg2.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    font-size: 50px;
    padding: 20px 0 0;
    box-sizing: border-box;
    .wx {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 28px;
      line-height: 1;
      padding: 10px 10px 0 0;
      img {
        width: 150px;
        margin-top: 10px;
      }
    }
    .xcx {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 28px;
      line-height: 1;
      padding: 10px 0 0 10px;
      img {
        width: 150px;
        margin-top: 10px;
      }
    }
    .search {
      @include flex();
      position: absolute;
      left: 50%;
      bottom: 40px;
      width: 800px;
      height: 66px;
      box-shadow: 0px 17px 38px 0px rgba(38, 118, 194, 0.18);
      border-radius: 50px;
      background: #fff;
      transform: translateX(-50%);
      padding: 0 75px 0 80px;
      box-sizing: border-box;
      .input {
        display: flex;
        align-items: center;
        color: #ccc;
        font-size: 16px;
        input {
          border: 0;
          outline: none;
          margin-left: 10px;
        }
      }
      .submit {
        background: #4b7ff7;
        width: 135px;
        height: 40px;
        color: #fff;
        font-size: 16px;
        line-height: 40px;
        cursor: pointer;
      }
    }
  }
  .content {
    .stat {
      margin: 14px auto;
      @include flex;
      width: 1000px;
      & > div {
        @include flex;
        width: 210px;
        height: 37px;
        line-height: 37px;
        padding: 0 26px 0 14px;
        border-radius: 14px;
        color: #fff;
        box-sizing: border-box;
        span {
          font-size: 18px;
          margin-right: 5px;
        }
      }
      .sch-num {
        background: $PictonBlue;
      }
      .stu-num {
        background: $TulipTree;
      }
      .com-num {
        background: $Fern;
      }
      .job-num {
        background: $Roman;
      }
    }
    .hot {
      width: 91px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      color: #4b7ff7;
      border: 1px solid rgba(75, 127, 247, 1);
      margin: 0 auto 14px;
    }
    .schools {
      display: flex;
      flex-wrap: wrap;
      width: 1175px;
      margin: 0 auto;
      .school {
        width: 227px;
        margin: 0 10px 40px 0;
        .logo {
          position: relative;
          height: 124px;
          background: rgba(0, 0, 0, 0.5);
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          text-align: center;
          line-height: 124px;
          color: #fff;
          font-size: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .logo::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
          width: 100%;
          height: 100%;
          background: url("../../assets/img/default-logo.png") no-repeat center
            center;
          background-size: 100% 100%;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        }

        .name {
          font-weight: bold;
          margin: 10px 0 0 8px;
        }
        .num {
          display: flex;
          justify-content: space-between;
          margin: 10px 0 0 8px;
          font-size: 13px;

          span {
            color: #ec6941;
          }
        }
        .join {
          height: 26px;
          background: #4b7ff7;
          border-radius: 5px;
          text-align: center;
          line-height: 26px;
          color: #fff;
          margin-top: 10px;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .school:nth-of-type(5n) {
        margin-right: 0;
      }
    }
  }

  .pay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    .wrapper {
      width: 300px;
      border-radius: 20px;
      margin: 250px auto;
      background: #fff;
      text-align: center;
      padding: 50px 50px 20px;
      .btn-wrap {
        margin-top: 50px;
        .el-button {
          width: 40%;
        }
      }
    }
  }
  .el-dialog {
    .el-select {
      width: 200px;
    }
    .area {
      .el-select {
        width: 180px;
        margin-right: 7px;
      }
    }
    .el-input {
      width: 200px;
    }
  }
}
.pop {
  height: calc(100vh - 60px);
  overflow: hidden;
}
.el-pagination {
  text-align: center;
}
</style>